export const zeros18 = new Array(18).fill('empty').map(_ => '--');
